<template>
  <form novalidate @submit.prevent="purchase" :class="{ center }">
    <section class="purchase">
      <div class="card-container">
        <div ref="card" />
      </div>

      <p class="error" v-if="errorMessage">
        {{ errorMessage }}
      </p>

      <button type="submit" :disabled="running">Pay $15</button>
    </section>
  </form>
</template>

<script>
const stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);
const elements = stripe.elements();
let card;

const style = {
  base: {
    color: '#2e2e2e',
    fontSize: '18px',
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: '#ADADAD',
    },
  },
  invalid: {
    color: '#e5424d',
    ':focus': {
      color: '#303238',
    },
  },
};

export default {
  props: {
    center: Boolean,
  },

  data() {
    return {
      errorMessage: null,
      running: false,
    };
  },

  mounted() {
    if (!card) {
      card = elements.create('card', { style });
    }

    card.mount(this.$refs.card);
  },

  methods: {
    purchase() {
      this.running = true;
      this.errorMessage = null;

      stripe.createToken(card)
        .then((result) => {
          if (result.error) {
            this.errorMessage = result.error.message;
            this.$forceUpdate();
            this.running = false;
          } else {
            this.$store.dispatch('draft/PURCHASE_DRAFT', result.token)
              .then(() => {
                this.$emit('success');
              })
              .catch(({ response }) => {
                this.errorMessage = response.data.message || 'There was an error making a purchase with this card. Unauthorized.';
                this.running = false;
              });
          }
        });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  form {
    width: 100%;

    &.center {
      margin: 0 auto;
    }
  }

  button {
    width: 100%;
  }

  .card-container {
    height: px-to-rem(54px);;
    display: flex;
    align-items: center;
    margin-bottom: $gp;
    background-color: $white-color;
    padding: $gp / 2 $gp;
    border: $base-border;
    border-radius: $border-radius;
  }
</style>

<style lang="scss" rel="stylesheet/scss">
  .StripeElement {
    height: 22px;
    width: 100%;
  }
</style>
